
import { BaseModel } from '../abstracts/base.model'

export class PasswordModel extends BaseModel {
    UserID: string
    CurrentPassword: string
    Password: string
    PasswordConfirm: string
    ForceChangePassword: boolean;
}